module.exports = __webpack_public_path__ + "static/media/profile2.6055211f.jpeg";